import React, { useEffect, useState } from 'react';

import { Button } from '~components';
import Modal from '~components/Modal';
import SelectLazy from '~components/form-fields/inputs/SelectLazy';

import { getAll as getClients } from '~main/actions/clients';
import { selectLookupClients } from '~main/selectors/clients/clients';

import { GocardlessMandate } from '~direct-debits/models';

interface ComponentProps {
  mandate: GocardlessMandate | null;
  isOpen: boolean;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: (clientId: number) => void;
}

const MandateLinkModal: React.FC<ComponentProps> = ({
  mandate,
  isOpen,
  isSubmitting = false,
  onCancel,
  onConfirm,
}) => {
  const [clientId, setClientId] = useState<number | null>(null);

  // Reset selection whenever the modal is reopened for a different mandate.
  useEffect(() => {
    if (isOpen) setClientId(null);
  }, [isOpen, mandate?.id]);

  const handleClientChange = (_id: string, value: number | null) => setClientId(value);
  const handleConfirm = () => {
    if (clientId === null) return;
    onConfirm(clientId);
  };

  const setIsOpen = (open: boolean) => {
    if (!open) onCancel();
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header="Link Mandate"
      includeFooter={false}
      backdrop="static"
    >
      <div className="d-flex flex-column gap-2">
        <div>
          <strong>Customer:</strong> {mandate?.customer_name ?? '—'}
        </div>
        <div>
          <strong>Reference:</strong> {mandate?.reference ?? '—'}
        </div>
        <label htmlFor="dd-mandate-link-client" className="mt-2 fw-semibold">
          TurnPoint client
        </label>
        <SelectLazy
          type="select-lazy"
          id="dd-mandate-link-client"
          name="client_id"
          value={clientId ?? undefined}
          placeholder="Search clients…"
          selectorOptions={selectLookupClients}
          selectorActions={getClients}
          manualReload
          onChange={handleClientChange}
        />
        <div className="d-flex justify-content-end gap-2 mt-3">
          <Button
            id="dd-mandate-link-cancel"
            data-cy="dd-mandate-link-cancel"
            color="secondary"
            outline
            onClick={onCancel}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            id="dd-mandate-link-confirm"
            data-cy="dd-mandate-link-confirm"
            color="primary"
            onClick={handleConfirm}
            disabled={clientId === null || isSubmitting}
          >
            Link
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MandateLinkModal;
